'use client'

import { useEffect, useState } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { CheckIcon } from '@heroicons/react/20/solid'
import Button from '@/app/components/Button'
import classNames from 'classnames'
import * as Sentry from "@sentry/nextjs"
import '@/instrumentation-client'

export default function NotFound() {

    const pathname = usePathname()
    const router = useRouter()
    const [ eventId, setEventId ] = useState(null)
    const [ copy, setCopy ] = useState(false)

    useEffect(() => {
        if (process.env.SENTRY_DSN) {
            const sentryEventId = Sentry.captureException(
                new Error(`404 Not Found: ${pathname}`)
            )
            setEventId(sentryEventId)
        }
    }, [])

    return (
        <div className="page-content bg-black-900 fixed top-0 z-[100]">
            <main className="h-full flex-center flex-col text-center">
                <div className="text-[2rem] text-main font-bold font-gotham">
                    404
                </div>
                <div className="text-[1rem] text-main font-bold font-gotham mb-8">
                    Page Not Found
                </div>
                { eventId &&
                    <div
                        className="px-5 relative flex-center cursor-pointer mb-20"
                        onClick={() => {
                            navigator.clipboard.writeText(eventId)
                            .then((e) => {
                                setCopy(true)
                            })
                        }}
                    >
                        <div className="text-[0.75rem] text-white">
                            {eventId.slice(0, 10)}
                        </div>
                        <div className="absolute right-0">
                            <DocumentDuplicateIcon
                                className={classNames('w-4 stroke-white hidden', {
                                    '!block': !copy
                                })}
                            />
                            <CheckIcon
                                className={classNames('w-4 fill-white hidden', {
                                    '!block': copy
                                })}
                            />
                        </div>
                    </div>
                }
                <Button
                    className="btn-main"
                    onClick={() => {router.push('/')}}
                    sound="return"
                >返回首頁</Button>
            </main>
        </div>
    )
}